/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import "./update-doctor-modal.css";
import { AiFillCloseCircle } from "react-icons/ai";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { updateDoctorDetails } from "../../../redux/apiCalls/doctorsApiCalls";
import { fetchAllDepartments } from "../../../redux/apiCalls/departmentApiCalls";
import { fetchAllCities } from "../../../redux/apiCalls/cityApiCalls";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";

const UpdateDoctorModal = ({ doctor, setUpdateDoctor }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const departments = useSelector((state) => state.department.departments);
  const cities = useSelector((state) => state.city.cities);

  const [name, setName] = useState(doctor.name);
  const [title, setTitle] = useState(doctor.title);
  const [department, setDepartment] = useState(doctor.department);
  const [description, setDescription] = useState(doctor.description);
  const [address, setAddress] = useState(doctor.address);
  const [mobile, setMobile] = useState(doctor.mobile);
  const [tell, setTell] = useState(doctor.tell);
  const [registrationType, setRegistrationType] = useState(
    doctor.registrationType
  );
  const [workingDay, setWorkingDay] = useState(doctor.workingDay);
  const [city, setCity] = useState(doctor.city);

  //Form submit handler
  const updateFormSubmitHandler = (e) => {
    e.preventDefault();

    if (name.trim() === "") {
      return toast.error("يجب ادخال الاسم");
    }
    if (title.trim() === "") {
      return toast.error("يجب ادخال المؤهل");
    }
    if (address.trim() === "") {
      return toast.error("يجب ادخال العنوان");
    }
    if (mobile.trim() === "") {
      return toast.error("يجب ادخال رقم الموبيل");
    }
    if (tell.trim() === "") {
      return toast.error("يجب ادخال رقم الهاتف");
    }
    if (workingDay.trim() === "") {
      return toast.error("يجب ادخال ايام العمل");
    }
    if (department.trim() === "") {
      return toast.error("يجب ادخال القسم");
    }
    if (registrationType.trim() === "") {
      return toast.error("يجب ادخال طريقة الحجز");
    }
    if (city.trim() === "") {
      return toast.error("يجب ادخال المدينة");
    }
    if (description.trim() === "") {
      return toast.error("يجب ادخال معلومات عن الطبيب");
    }
    dispatch(
      updateDoctorDetails(
        {
          name,
          title,
          address,
          mobile,
          tell,
          workingDay,
          department,
          registrationType,
          city,
          description,
        },
        doctor?._id
      )
    );
    setUpdateDoctor(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllCities());
  }, []);

  return (
    <div className="update-doctor">
      <form onSubmit={updateFormSubmitHandler} className="update-doctor-form ">
        <div className="update-doctor-form-color"></div>
        <abbr title="close">
          <AiFillCloseCircle
            onClick={() => setUpdateDoctor(false)}
            className="update-doctor-form-close"
          />
        </abbr>
        <h4>تحديث بيانات طبيب</h4>
        <div className="update-doctor-page-form-row">
          <input
            type="text"
            placeholder="اسم الطبيب"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="text"
            placeholder="المؤهل "
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            type="text"
            placeholder="العنوان "
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        <div className="update-doctor-page-form-row">
          <input
            type="text"
            placeholder=" الموبيل"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          <input
            type="text"
            placeholder=" التليفون"
            value={tell}
            onChange={(e) => setTell(e.target.value)}
          />
          <input
            type="text"
            placeholder=" ايام العمل"
            value={workingDay}
            onChange={(e) => setWorkingDay(e.target.value)}
          />
        </div>

        <div className="update-doctor-page-form-row">
          <input
            type="text"
            placeholder="كيفية الحجز"
            value={registrationType}
            onChange={(e) => setRegistrationType(e.target.value)}
          />

          <Form.Select
            onChange={(e) => setDepartment(e.target.value)}
            aria-label="التخصص"
          >
            <option disabled>التخصص</option>
            {departments?.map((dep) => (
              <option key={dep?._id} value={dep?.title}>
                {dep?.title}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            onChange={(e) => setCity(e.target.value)}
            aria-label="المدينة"
          >
            <option disabled>المدينة</option>
            {cities?.map((city) => (
              <option value={city?.cityName} key={city._id}>
                {city?.cityName}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="update-doctor-page-form-row">
          <textarea
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            rows="4"
            placeholder=" عن الطبيب"
          ></textarea>
        </div>

        <div className="update-doctor-page-form-row">
          <button type="submit" className="update-doctor-page-btn">
            أضافة
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateDoctorModal;
